import React, { useState, useRef, useEffect } from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/solid';

const OPTIONS = [
  { value: 'desc', label: 'Date descending', Icon: ArrowDownIcon },
  { value: 'asc', label: 'Date ascending', Icon: ArrowUpIcon },
];

const DropdownOrderBy = ({ value = 'desc', onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const current = OPTIONS.find((o) => o.value === value) || OPTIONS[0];
  const CurrentIcon = current.Icon;

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="p-1.5 rounded text-white hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
        title="Order by date"
        aria-label="Order by date"
      >
        <CurrentIcon className="h-5 w-5" />
      </button>
      {open && (
        <div className="absolute right-0 top-full z-20 mt-1 min-w-[180px] rounded-md bg-white shadow-lg border border-gray-200 py-1">
          {OPTIONS.map((opt) => {
            const Icon = opt.Icon;
            const isSelected = value === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                className={`w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-gray-50 ${
                  isSelected ? 'text-green-600 bg-green-50' : 'text-gray-700'
                }`}
              >
                <Icon className="h-4 w-4 shrink-0" />
                <span>{opt.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DropdownOrderBy;
